'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { omitThemingProps } from '@chakra-ui/styled-system';
import { callAll } from '@chakra-ui/utils';
import { useRadioGroupContext, RadioItemStylesProvider, RadioItemContextProvider } from './radio-group-context.mjs';
import { splitRadioItemProps } from './radio-group-props.mjs';
import { useRadio } from './use-radio.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { useMultiStyleConfig } from '../system/use-style-config.mjs';
import { chakra } from '../system/factory.mjs';

const RadioGroupItem = forwardRef(
  function RadioGroupItem2(props, ref) {
    const ownProps = omitThemingProps(props);
    const api = useRadioGroupContext();
    const styles = useMultiStyleConfig("Radio", { ...api, ...props });
    const { children, inputProps, ...restProps } = ownProps;
    const [itemProps, rootProps] = splitRadioItemProps(restProps);
    if (api?.value != null && itemProps.value != null) {
      itemProps.isChecked = api.value === itemProps.value;
    }
    if (api?.onChange && itemProps.value != null) {
      itemProps.onChange = callAll(api.onChange, itemProps.onChange);
    }
    if (api?.name) {
      itemProps.name = api.name;
    }
    if (api?.isDisabled) {
      itemProps.isDisabled = api.isDisabled;
    }
    if (api?.isFocusable) {
      itemProps.isFocusable = api.isFocusable;
    }
    const itemApi = useRadio(itemProps);
    return /* @__PURE__ */ jsxs(chakra.label, { className: "chakra-radio", ...rootProps, __css: styles.root, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          className: "chakra-radio__input",
          ...itemApi.getInputProps(inputProps, ref)
        }
      ),
      /* @__PURE__ */ jsx(RadioItemStylesProvider, { value: styles, children: /* @__PURE__ */ jsx(RadioItemContextProvider, { value: itemApi, children }) })
    ] });
  }
);
RadioGroupItem.displayName = "RadioGroupItem";

export { RadioGroupItem };
